import $ from 'jquery';
import 'slick-carousel';

$(document).ready(function() {
	
	var fields = [ "input", "textarea" ];
	$(fields).each(function() {
		$(this).on('focus', function() {
  			$(this).parent().parent('.gfield').addClass('active');
		});
		
		$(this).on('blur', function() {
  		if ($(this).val().length == 0) {
			$(this).parent().parent('.gfield').removeClass('active');
  		}
		});
		if ($(this).val() != '') $(this).parent('.css').addClass('active');
	
	});
	
	$('.accordion-item:first-of-type > p > .accordion-button').attr("aria-expanded","true");
	
	$('.nav-tabs > .nav-link:first-of-type').addClass('active');
	$('.tab-content > .tab-pane:first-of-type').addClass('show active');

	$('#header .navbar a[href*="#"]:not([href="#"])').click(function() {
		var target = $(this.hash);
		$('html,body').stop().animate({
			scrollTop: target.offset().top - 100
		}, 'linear');
	});
	if (location.hash){
		var id = $(location.hash);
	}
	$(window).on('load', function() {
		if (location.hash){
			$('html,body').animate({scrollTop: id.offset().top -100}, 'linear')
		}
	});
		
});